import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ProgressHeaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "flex-end",
        alignItems: "baseline",
        flexDirection: "row"
    }
});

export const useStyles = ({
    spaces
}: ProgressHeaderDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
